import UAParser from 'ua-parser-js'

export default (function () {
    const api = {}

    api.parser = new UAParser(window.navigator.userAgent)

    api.formatAttribute = function (string) {
        return string.replaceAll(' ', '-').toLowerCase()
    }

    api.getResult = function () {
        return api.parser.getResult()
    }

    api.getMajorBrowserVersion = function () {
        const version = api.getResult().browser.version
        return version.match(/^[\d]+/g)[0]
    }

    api.setBrowserAttributes = function () {
        document.documentElement.setAttribute('data-browser', api.formatAttribute(api.getResult().browser.name))
        document.documentElement.setAttribute('data-browser-version', api.getMajorBrowserVersion())
    }

    api.setOsAttribute = function () {
        document.documentElement.setAttribute('data-os', api.formatAttribute(api.getResult().os.name))
    }

    api.setAttributes = function () {
        api.setBrowserAttributes()
        api.setOsAttribute()
    }

    return api
})()
